import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/linkedin-scheduler")({
	beforeLoad: () => {
		throw redirect({ to: "/channels/linkedin" });
	},
});
